export default __webpack_public_path__ + "static/media/pic15-1.b530b205.jpg";